import {useWatch} from "react-hook-form";
import {
    PermitApplicationClearingFormFields,
    PermitApplicationCuttingFormFields,
    PermitApplicationFellingFormFields,
    PermitApplicationTransportFormFields,
    PermitApplicationTypesFormField,
} from "./form";
import {DividerWithHeading} from "base/ui/headings/components";
import {MapBaseLayout, useMapDialog} from "base/map/layout";
import {PermitApplicationTechinalDataMapProvider} from "plot/map";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";

const PermitApplicationTypesContent = ({permit, isStepEditable}) => {
    const {button, getDialog} = useMapDialog();

    const types = useWatch({
        name: "types",
    });

    const sections = [
        {
            label: "Abate",
            content: <PermitApplicationFellingFormFields disabled={!isStepEditable} />,
            hide: !types?.includes("felling"),
        },
        {
            label: "Serragem",
            content: <PermitApplicationCuttingFormFields disabled={!isStepEditable} />,
            hide: !types?.includes("cutting"),
        },
        {
            label: "Desbravamento",
            content: <PermitApplicationClearingFormFields disabled={!isStepEditable} />,
            hide: !types?.includes("clearing"),
        },
        {
            label: "Transporte",
            content: (
                <PermitApplicationTransportFormFields disabled={!isStepEditable} />
            ),
            hide: !types?.includes("transport"),
        },
    ];

    return (
        <>
            <Grid container mt={2}>
                <Grid item xs={6} md={9}>
                    <PermitApplicationTypesFormField disabled={!isStepEditable} />
                </Grid>
                <Grid
                    item
                    container
                    xs={6}
                    md={3}
                    justifyContent="center"
                    alignItems="center"
                >
                    <span>{button}</span>
                    {getDialog(
                        <PermitApplicationTechinalDataMapProvider permit={permit}>
                            <MapBaseLayout height="100%" />
                        </PermitApplicationTechinalDataMapProvider>
                    )}
                </Grid>
            </Grid>
            {sections.map((section, index) =>
                !section.hide ? (
                    <Stack key={index} mt={3}>
                        <DividerWithHeading label={section.label} />
                        {section.content}
                    </Stack>
                ) : null
            )}
        </>
    );
};

export default PermitApplicationTypesContent;
